/**
 * nuget-registry.ts — NuGet version lookups shared by `ss upgrade` (target
 * resolution, `SmartStack.*` family) and `ss doctor` (socle vs latest).
 *
 * Offline-tolerant by contract: an unreachable registry returns null (callers
 * fail closed or degrade to an info line); an id NuGet does not know returns []
 * (a private package is "not published", not "network down").
 */
const FETCH_TIMEOUT_MS = 15_000;

export async function getNuGetVersions(packageId: string): Promise<string[] | null> {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), FETCH_TIMEOUT_MS);
  try {
    const response = await fetch(`https://api.nuget.org/v3-flatcontainer/${packageId.toLowerCase()}/index.json`, { signal: ctrl.signal });
    if (response.status === 404) return [];
    if (!response.ok) return null;
    const data = await response.json() as { versions?: string[] };
    return data.versions ?? [];
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}
